import styled from 'styled-components';

const ThumbnailInlineContainer = styled.div`
  .wistia_click_to_play {
    display: block;
  }
`;

export { ThumbnailInlineContainer };
